const middleware = {}

middleware['keepUser'] = require('../middleware/keepUser.js')
middleware['keepUser'] = middleware['keepUser'].default || middleware['keepUser']

middleware['redirect'] = require('../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

export default middleware
